// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_h0-0";
export var headerCellHover = "_h0-1";
export var readCellContainer = "_h0-2";
export var unreadIndicator = "_h0-3";